
define('tmpl!core/templates/webidl/serializer.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlSerializer\'>{{extAttr obj indent true\n}}{{idn indent}}serializer{{#if values}} = <span class=\'idlSerializerValues\'>{{values}}</span>{{/if}};</span>\n');});

